export const findColor = (color, theme, variant) => {
    if (color === 'white' || color === 'black') {
        return theme.colors.common[color];
    }
    if (variant && variant in theme.colors[color]) {
        return theme.colors[color][variant];
    }
    return theme.colors[color].main;
};
export const intersectThemes = (baseTheme, otherTheme) => {
    const result = { ...baseTheme };
    const primary = {
        main: otherTheme?.colors?.primary?.main ?? '',
        light: otherTheme?.colors?.primary?.light ?? '',
        dark: otherTheme?.colors?.primary?.dark ?? '',
        contrastText: otherTheme?.colors?.primary?.contrastText ?? ''
    };
    const secondary = {
        main: otherTheme?.colors?.secondary?.main ?? '',
        light: otherTheme?.colors?.secondary?.light ?? '',
        dark: otherTheme?.colors?.secondary?.dark ?? '',
        contrastText: otherTheme?.colors?.secondary?.contrastText ?? ''
    };
    if (primary.contrastText != '' &&
        primary.dark != '' &&
        primary.light != '' &&
        primary.main != '') {
        result.colors.primary = primary;
    }
    if (secondary.contrastText != '' &&
        secondary.dark != '' &&
        secondary.light != '' &&
        secondary.main != '') {
        result.colors.secondary = secondary;
    }
    const borderRadius = otherTheme?.borderRadius;
    if (borderRadius) {
        result.borderRadius = borderRadius;
    }
    const inputVariant = otherTheme?.inputVariant;
    if (inputVariant) {
        result.inputVariant = inputVariant;
    }
    return result;
};
